import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { LIBERTY_MUTUAL_2024_QUERY } from '../../../graphql.js'
import { csvUrl, currencyFormatter, getData, getInputParams } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'
import TotalsRow from '../TotalsRow.js'

const LIBERTY_MUTUAL_2024 = gql(LIBERTY_MUTUAL_2024_QUERY)

export default function LibertyMutual2024({ location }) {
  console.log('LibertyMutual2024 rendered', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, LIBERTY_MUTUAL_2024, 'libertyMutual2024', setResults, setGraphQLErrors)
  }, [location])

  let total = 0

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    console.log(results)
    const inputs = getInputParams(location)
    //console.log(inputs)
    const totalColSpan = inputs.showStatus ? 16 : 15
    //console.log(totalColSpan)
    for (let i = 0; i < results.reportData.length; i++) {
      results.reportData[i][7] = results.reportData[i][7].replaceAll('&nbsp;', ' ')
      if (results.reportData[i][7].length > 50) {
        results.reportData[i][7] = `${results.reportData[i][7].substr(0, 50)} ...`
      }
    }
    const resultRows = ResultsGrid(results, 0, null, null, null, totalColSpan, currencyFormatter(), number => total += parseFloat(number)*100)
    total /= 100
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('Asbestos/libertyMutual2024/liberty_mutual_2024', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Paid Defense Fees Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
            <TotalsRow columnNumber={totalColSpan} total={total} />
          </tbody>
        </Table>
      </div>
    )
  }
}